import { useQuery } from 'react-query'
import settings from '../../components/settings'
import features from '../../components/features/'

export const useIpLocation = (enabled) =>
  useQuery(
    ['ip-location'],
    () =>
      fetch(settings.ipLocationAPI)
        .then((res) => res.json())
        .then((location) => ({
          city: location?.address?.city,
          countryName: location?.address?.country_name,
          postalCode: location?.address?.zip,
          latitude: location?.latitude,
          longitude: location?.longitude,
        }))
        .catch(() => ({})),
    { retry: 2, enabled: enabled && !features.disableIpLocation }
  )
